/**
 * First we will load all of this project's JavaScript dependencies which
 * includes React and other helpers. It's a great starting point while
 * building robust, powerful web applications using React + Laravel.
 */

import App from "@routes";
import "mapbox-gl/dist/mapbox-gl.css";
import React from "react";
import "react-alice-carousel/lib/alice-carousel.css";
import "react-datepicker/dist/react-datepicker.css";
import ReactDOM from "react-dom/client";
import initGa4 from "./utils/Ga4";

if ("serviceWorker" in navigator) {
  navigator?.serviceWorker?.register("/sw.js");
}
require("./bootstrap");

// import GA4
initGa4();

const rootElement = ReactDOM.createRoot(document.getElementById("app"));
rootElement.render(<App />);
